import ShoppingBag from '../../src/legacy/ShoppingBag.tsx';
export default ShoppingBag;
